import {NgModule} from '@angular/core';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule, HTTP_INTERCEPTORS, HttpClientJsonpModule} from '@angular/common/http';
import {BrowserModule} from '@angular/platform-browser';
import {DatePipe, HashLocationStrategy, LocationStrategy} from '@angular/common';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppRoutingModule} from './app-routing.module';

import {AccordionModule} from 'primeng/accordion';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {BreadcrumbModule} from 'primeng/breadcrumb';
import {ButtonModule} from 'primeng/button';
import {CalendarModule} from 'primeng/calendar';
import {CardModule} from 'primeng/card';
import {CarouselModule} from 'primeng/carousel';
import {ChartModule} from 'primeng/chart';
import {CheckboxModule} from 'primeng/checkbox';
import {ChipsModule} from 'primeng/chips';
import {CodeHighlighterModule} from 'primeng/codehighlighter';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ColorPickerModule} from 'primeng/colorpicker';
import {ContextMenuModule} from 'primeng/contextmenu';
import {DataViewModule} from 'primeng/dataview';
import {DialogModule} from 'primeng/dialog';
import {DropdownModule} from 'primeng/dropdown';
import {FieldsetModule} from 'primeng/fieldset';
import {FileUploadModule} from 'primeng/fileupload';
import {FullCalendarModule} from 'primeng/fullcalendar';
import {GalleriaModule} from 'primeng/galleria';
import {InplaceModule} from 'primeng/inplace';
import {InputNumberModule} from 'primeng/inputnumber';
import {InputMaskModule} from 'primeng/inputmask';
import {InputSwitchModule} from 'primeng/inputswitch';
import {InputTextModule} from 'primeng/inputtext';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {LightboxModule} from 'primeng/lightbox';
import {ListboxModule} from 'primeng/listbox';
import {MegaMenuModule} from 'primeng/megamenu';
import {MenuModule} from 'primeng/menu';
import {MenubarModule} from 'primeng/menubar';
import {MessagesModule} from 'primeng/messages';
import {MessageModule} from 'primeng/message';
import {MultiSelectModule} from 'primeng/multiselect';
import {OrderListModule} from 'primeng/orderlist';
import {OrganizationChartModule} from 'primeng/organizationchart';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import {PaginatorModule} from 'primeng/paginator';
import {PanelModule} from 'primeng/panel';
import {PanelMenuModule} from 'primeng/panelmenu';
import {PasswordModule} from 'primeng/password';
import {PickListModule} from 'primeng/picklist';
import {ProgressBarModule} from 'primeng/progressbar';
import {RadioButtonModule} from 'primeng/radiobutton';
import {RatingModule} from 'primeng/rating';
import {RippleModule} from 'primeng/ripple';
import {ScrollPanelModule} from 'primeng/scrollpanel';
import {SelectButtonModule} from 'primeng/selectbutton';
import {SidebarModule} from 'primeng/sidebar';
import {SlideMenuModule} from 'primeng/slidemenu';
import {SliderModule} from 'primeng/slider';
import {SplitButtonModule} from 'primeng/splitbutton';
import {StepsModule} from 'primeng/steps';
import {TabMenuModule} from 'primeng/tabmenu';
import {TableModule} from 'primeng/table';
import {TabViewModule} from 'primeng/tabview';
import {TerminalModule} from 'primeng/terminal';
import {TieredMenuModule} from 'primeng/tieredmenu';
import {ToastModule} from 'primeng/toast';
import {ToggleButtonModule} from 'primeng/togglebutton';
import {ToolbarModule} from 'primeng/toolbar';
import {TooltipModule} from 'primeng/tooltip';
import {TreeModule} from 'primeng/tree';
import {TreeTableModule} from 'primeng/treetable';
import {VirtualScrollerModule} from 'primeng/virtualscroller';
import { TimelineModule } from 'primeng/timeline';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

import {AppCodeModule} from './app.code.component';
import {AppComponent} from './app.component';
import {AppMainComponent} from './app.main.component';
import {AppConfigComponent} from './app.config.component';
import {AppMenuitemComponent} from './app.menuitem.component';
import {AppInlineMenuComponent} from './app.inlinemenu.component';
import {AppBreadcrumbComponent} from './app.breadcrumb.component';
import {AppTopBarComponent} from './app.topbar.component';
import { AppFooterComponent } from './app.footer.component';

import {AppInvoiceComponent} from './pages/app.invoice.component';
import {AppHelpComponent} from './pages/app.help.component';
import {AppNotfoundComponent} from './pages/app.notfound.component';
import {AppErrorComponent} from './pages/app.error.component';
import {AppAccessdeniedComponent} from './pages/app.accessdenied.component';
import {AppLandingComponent} from './pages/app.landing.component';

import {MenuService} from './app.menu.service';
import {AppBreadcrumbService} from './app.breadcrumb.service';
import {AppContactusComponent} from './pages/app.contactus.component';
import { HomeComponent } from './home/home.component';
import { NewsAddComponent } from './news/news-add/news-add.component';

import { EditorModule } from 'primeng/editor';
import { ValidateformComponent } from './common/validateform/validateform.component';
import { RequiredNospaceValidatorDirective } from './common/validators/required-nospace-validator.directive';
import { DecimalValidatorDirective } from './common/validators/decimal-validator.directive';
import { TelephoneValidatorDirective } from './common/validators/telephone-validator.directive';
import { EmailValidatorDirective } from './common/validators/email-validator.directive';
import { UrlValidatorDirective } from './common/validators/url-validator.directive';
import { MessageViewComponent } from './message/message-view/message-view.component';
import { ConvertToDatetimePipe } from './common/pipes/convert-to-datetime.pipe';
import { ConvertToDateOnlyPipe } from './common/pipes/convert-to-date-only.pipe';
import { ConvertYesNoPipe } from './common/pipes/convert-yes-no.pipe';
import { PhoneNumberPipe } from './common/pipes/phonenumber.pipe';
import { SpinnerComponent } from './common/spinner/spinner.component';
import { SpinnerInterceptor } from './common/interceptors/spinner.interceptor';
import { AuthenticationInterceptor } from './common/interceptors/authentication.interceptor';
import { ViewnewsitemComponent } from './news/news-view-item/news-view-item.component';
import { MessageAddComponent } from './message/message-add/message-add.component';
import { RouterModule } from '@angular/router';
import { MessageReviewComponent } from './message/message-review/message-review.component';
import { ConfirmationService } from 'primeng/api';
import { DividerModule } from 'primeng/divider';
import { ResourceCenterViewComponent } from './resource/resource-center-view/resource-center-view.component';
import { ResourceListViewComponent } from './resource/resource-list-view/resource-list-view.component';
import { MessageDetailComponent } from './message/message-detail/message-detail.component';
import { CalendarComponent } from './calendar/calendar.component';
import { DataMiningSearchComponent } from './datamining/datamining-search/datamining-search.component';
import { DataminingDetailComponent } from './datamining/datamining-detail/datamining-detail.component';
import { ResourceAddEditComponent } from './resource/resource-add-edit/resource-add-edit.component';
import { UserViewComponent } from './user/user-view/user-view.component';
import { UserInviteComponent } from './user/user-invite/user-invite.component';
import { UserPasswordResetComponent } from './user/user-password-reset/user-password-reset.component';
import { UserLoginComponent } from './user/user-login/user-login.component';
import { UserForgotpasswordComponent } from './user/user-forgotpassword/user-forgotpassword.component';
import { MemberAddComponent } from './member/member-add/member-add.component';
import { UserEditComponent } from './user/user-edit/user-edit.component';
import { MemberViewComponent } from './member/member-view/member-view.component';
import { MemberEditComponent } from './member/member-edit/member-edit.component';
import { DealAddComponent } from './deal/deal-add/deal-add.component';
import { DealDetailComponent } from './deal/deal-detail/deal-detail.component';
import { DealEditComponent } from './deal/deal-edit/deal-edit.component';
import { DealNoteComponent } from './deal/deal-note/deal-note.component';
import { DealAdditionalCommunicationComponent } from './deal/deal-additional-communication/deal-additional-communication.component';
import { AgmCoreModule } from '@agm/core';
import { SearchComponent } from './search/search.component';
import { MemberterritoryEditComponent } from './member/memberterritory-edit/memberterritory-edit.component';
import { GeocodeService } from './services/geocode.service';
import { DealViewComponent } from './deal/deal-view/deal-view.component';
import { ReportComponent } from './report/report.component';
import { CookieService } from 'ngx-cookie-service';
import { AccountService } from './services/AccountService';
import { utility } from './common/utility';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        AppRoutingModule,
        HttpClientModule,
        HttpClientJsonpModule,
        BrowserAnimationsModule,
        AccordionModule,
        AutoCompleteModule,
        BreadcrumbModule,
        ButtonModule,
        CalendarModule,
        CardModule,
        CarouselModule,
        ChartModule,
        CheckboxModule,
        ChipsModule,
        CodeHighlighterModule,
        ConfirmDialogModule,
        ColorPickerModule,
        ContextMenuModule,
        DataViewModule,
        DialogModule,
        DropdownModule,
        FieldsetModule,
        FileUploadModule,
        FullCalendarModule,
        GalleriaModule,
        TimelineModule,
        InplaceModule,
        InputNumberModule,
        InputMaskModule,
        InputSwitchModule,
        InputTextModule,
        InputTextareaModule,
        LightboxModule,
        ListboxModule,
        MegaMenuModule,
        MenuModule,
        MenubarModule,
        MessageModule,
        MessagesModule,
        MultiSelectModule,
        OrderListModule,
        OrganizationChartModule,
        OverlayPanelModule,
        PaginatorModule,
        PanelModule,
        PanelMenuModule,
        PasswordModule,
        PickListModule,
        ProgressBarModule,
        RadioButtonModule,
        RatingModule,
        RippleModule,
        ScrollPanelModule,
        SelectButtonModule,
        SidebarModule,
        SlideMenuModule,
        SliderModule,
        SplitButtonModule,
        StepsModule,
        TableModule,
        TabMenuModule,
        TabViewModule,
        TerminalModule,
        TieredMenuModule,
        ToastModule,
        ToggleButtonModule,
        ToolbarModule,
        TooltipModule,
        TreeModule,
        TreeTableModule,
        VirtualScrollerModule,
        AppCodeModule,
        EditorModule,
        ProgressSpinnerModule,
        RouterModule,
        DividerModule,
        ReactiveFormsModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyDw41NWpMcbjfYt3F2qJMiUwEm1CxdDIQY',
            libraries: ['places']
          })
       
    ],
    declarations: [
        AppComponent,
        AppMainComponent,
        AppConfigComponent,
        AppMenuitemComponent,
        AppInlineMenuComponent,
        AppBreadcrumbComponent,
        AppTopBarComponent,
        AppFooterComponent,       
        AppLandingComponent,
        AppInvoiceComponent,
        AppHelpComponent,
        AppNotfoundComponent,
        AppErrorComponent,
        AppAccessdeniedComponent,
        AppContactusComponent,
        HomeComponent,
        NewsAddComponent,
        ValidateformComponent,
        RequiredNospaceValidatorDirective,
        DecimalValidatorDirective,
        TelephoneValidatorDirective,
        EmailValidatorDirective,
        UrlValidatorDirective,
        MessageViewComponent,
        ConvertToDatetimePipe,
        ConvertToDateOnlyPipe,
        ConvertYesNoPipe,
        SpinnerComponent,
        MessageAddComponent,
        MessageReviewComponent,
        ViewnewsitemComponent,
        MessageDetailComponent,
        CalendarComponent,
        DataMiningSearchComponent,
        DataminingDetailComponent,
        ResourceCenterViewComponent,
        ResourceListViewComponent,      
        ResourceAddEditComponent,
        UserViewComponent,
        UserInviteComponent,
        UserPasswordResetComponent,
        UserLoginComponent,
        UserForgotpasswordComponent,        
        MemberAddComponent,
        UserEditComponent,
        MemberViewComponent,
        MemberEditComponent,
        DealAddComponent,
        DealDetailComponent,
        DealEditComponent,
        DealNoteComponent,        
        SearchComponent,
        MemberterritoryEditComponent,
        DealAdditionalCommunicationComponent,
        DealViewComponent,
        ReportComponent,
        PhoneNumberPipe
    ],
    providers: [
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: SpinnerInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthenticationInterceptor,
            multi: true
        },
        MenuService, AppBreadcrumbService, ConfirmationService, DatePipe, CookieService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(public accountService: AccountService) {
        utility.accountService = accountService;
    }
}
